import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { FlaskConical, ShieldAlert } from "lucide-react";

export default function AgeGate() {
  const [open, setOpen] = useState(() => !localStorage.getItem("crp_age_verified"));
  const [denied, setDenied] = useState(false);

  const confirm = () => {
    localStorage.setItem("crp_age_verified", "1");
    setOpen(false);
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid="age-gate"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          className="fixed inset-0 z-[80] flex items-center justify-center bg-[#050505] px-6"
        >
          <div className="w-full max-w-lg border border-white/15 bg-[#0A0A0A] p-10">
            <div className="mb-8 flex items-center gap-3">
              <FlaskConical className="h-6 w-6 text-[#00ff72]" />
              <span className="font-mono text-xs tracking-[0.3em] text-[#A3A3A3]">
                SFH BIOHEALTH &amp; WELLNESS
              </span>
            </div>
            <p className="font-mono text-[10px] tracking-[0.3em] text-[#00ff72]">AGE VERIFICATION REQUIRED</p>
            <h2 className="mt-3 font-display text-4xl leading-tight">Research Purposes Only</h2>
            <p className="mt-4 text-sm leading-relaxed text-[#A3A3A3]">
              Products on this site are intended solely for laboratory research. Not for human
              consumption or therapeutic use.
            </p>
            <ul className="mt-6 space-y-2 border-t border-white/10 pt-6 text-sm text-[#F9F6F0]">
              <li className="flex gap-3"><span className="text-[#00ff72]">&#9656;</span> You are at least 21 years of age</li>
              <li className="flex gap-3"><span className="text-[#00ff72]">&#9656;</span> You are a qualified researcher</li>
              <li className="flex gap-3"><span className="text-[#00ff72]">&#9656;</span> You understand these are for research only</li>
              <li className="flex gap-3"><span className="text-[#00ff72]">&#9656;</span> You agree to our Terms of Service</li>
            </ul>
            {denied ? (
              <p data-testid="age-gate-denied" className="mt-8 border border-red-500/40 bg-red-500/10 p-4 font-mono text-xs leading-relaxed text-red-400">
                ACCESS DENIED. You must be 21+ and agree to the terms to enter this site.
              </p>
            ) : (
              <div className="mt-8 flex flex-col gap-3 sm:flex-row">
                <button
                  data-testid="age-gate-confirm-btn"
                  onClick={confirm}
                  className="flex-1 bg-[#00ff72] px-6 py-4 font-mono text-xs tracking-[0.2em] text-black transition-colors hover:bg-[#00d165]"
                >
                  I CONFIRM — ENTER SITE
                </button>
                <button
                  data-testid="age-gate-exit-btn"
                  onClick={() => setDenied(true)}
                  className="flex-1 border border-white/20 px-6 py-4 font-mono text-xs tracking-[0.2em] text-[#A3A3A3] transition-colors hover:border-red-500/60 hover:text-red-400"
                >
                  <span className="inline-flex items-center gap-2">
                    <ShieldAlert className="h-4 w-4" /> I DO NOT AGREE
                  </span>
                </button>
              </div>
            )}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
